module.exports = {"SearchBar":{"RecentSearches":"Recent searches"},"CookieDisclaimer":{"link":"discover/marketing-terms-and-conditions/privacy-policy-cookies/?r=1"},"MiniBag":{"Footer":{"DeliveryProposition":{"Title":"Free Shipping Worldwide*","Description":"More info ","LinkText":"here","DeliveryInformationLink":"customer-service/delivery/"}}}}


//////////////////
// WEBPACK FOOTER
// ../i18n/en-au.json
// module id = ../i18n/en-au.json
// module chunks = client.sitechrome